<template lang='pug'>
  v-container
    v-card(light, flat)
      v-card-title
        span Customer Requests
        v-spacer
        v-switch(label='Show Closed Requests', color='brand', v-model='showClosed')
        v-btn(@click='getAllRequests', icon)
            v-icon refresh
      v-card-text
        v-data-table(:headers='headers', :items='requests', @click:row='viewRequestData')
            template(v-slot:item.type='{item, value}')
                span {{getRequestType(value)}}
            template(v-slot:item.subType='{item}')
                span {{getRequestSubType(item)}}
            template(v-slot:item.createdAt='{value}')
                span {{formatDate(value)}}
            template(v-slot:item.closedDate='{value}')
                span {{formatDate(value)}}
            template(v-slot:item.closed='{value}')
                v-icon(error) {{value ? 'close' : ''}}
            template(v-slot:item.completed='{value}')
                v-icon(color='success') {{value ? 'check' : ''}}
    v-dialog(v-model='showRequestDetails', max-width='750', persistent)
        router-view(
            @close='closeDetails',
            @refresh='getAllRequests',
        )
    v-overlay(absolute, :value='busy')
        .text-h6 Please Wait...
        v-progress-linear(indeterminate)
</template>
<script>
import SubscriptionRequest from '@/components/devops/requests/details';
export default {
    components: {
        SubscriptionRequest
    },
    props: {

    },
    data () {
        return {
            busy: false,
            showRequestDetails: false,
            selectedRequest: null,
            showClosed: false,
            requests: [],
            accessKey: 'customersrequests'
        };
    },
    computed: {
        headers () {
            const headers = [
                {
                    text: 'Type',
                    value: 'type'
                },
                {
                    text: 'SubType',
                    value: 'subType'
                },
                {
                    text: 'Created',
                    value: 'createdAt'
                },
                {
                    text: 'Customer',
                    value: 'customer.name'
                },
            ];
            if (this.showClosed) {
                headers.push(...[
                    {
                        text: 'Closed Date',
                        value: 'closedDate'
                    },
                    {
                        text: 'Complete',
                        value: 'completed'
                    },
                    {
                        text: 'Closed',
                        value: 'closed'
                    }
                ]);
            }
            return headers;
        }
    },
    methods: {
        async getAllRequests () {
            const reqs = await this.sendCommand({
                action: 'getAllCustomerRequests',
                parameters: {
                    includeClosed: this.showClosed
                }
            });
            this.requests = reqs;
        },
        getRequestType (reqType) {
            switch (reqType) {
                case 'subscription_activation':
                    return 'Subscription Activation Request';
                default:
                    return 'Unknown';
            }
        },
        getRequestSubType (request) {
            if (request.customersSubscriptionRequest) {
                return request.customersSubscriptionRequest.type;
            }
            // handle future types here.
        },
        formatDate (date) {
            if (!date) {
                return '';
            }
            date = new Date(date);
            return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
        },
        viewRequestData (reqData) {
            this.$router.push(`requests/${reqData.id}/details`);
            this.showRequestDetails = true;
            // this.selectedRequest = reqData;
        },
        closeDetails () {
            this.showRequestDetails = false;
            this.$router.push('/devops/requests');
        }
    },
    mounted () {
        this.getAllRequests();
    },
    watch: {
        '$route.params.id': {
            handler (id) {
                if (id) {
                    this.showRequestDetails = true;
                }
            },
            immediate: true
        },
        showClosed () {
            this.getAllRequests();
        }
    }
}
</script>